import Icon from '@ant-design/icons';
import React from 'react';

const OrderDraftSvg = (props: React.HTMLAttributes<SVGElement>) => (
  <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.3333 2.66667H15.76C15.2 1.12 13.7333 0 12 0C10.2667 0 8.8 1.12 8.24 2.66667H2.66667C1.2 2.66667 0 3.86667 0 5.33333V24C0 25.4667 1.2 26.6667 2.66667 26.6667H21.3333C22.8 26.6667 24 25.4667 24 24V5.33333C24 3.86667 22.8 2.66667 21.3333 2.66667ZM12 2.66667C12.7333 2.66667 13.3333 3.26667 13.3333 4C13.3333 4.73333 12.7333 5.33333 12 5.33333C11.2667 5.33333 10.6667 4.73333 10.6667 4C10.6667 3.26667 11.2667 2.66667 12 2.66667ZM14.6667 21.3333H5.33333V18.6667H14.6667V21.3333ZM18.6667 16H5.33333V13.3333H18.6667V16ZM18.6667 10.6667H5.33333V8H18.6667V10.6667Z"
      fill="#202426"
    />
  </svg>
);

export const OrderDraftIcon = ({ className, ...props }: React.ComponentProps<typeof Icon>) => (
  <Icon component={() => <OrderDraftSvg className={className} />} {...props} />
);
